module.exports = __webpack_public_path__ + "static/media/icon-edit.269aa82b.svg";